import React from "react"
import { Helmet } from "react-helmet"
import MainNav from "./MainNav"
import Footer from "./Footer"
import("../styles/main.scss")

class Layout extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      width: 0,
      isMobile: false,
    }
  }

  componentDidMount() {
    this.handleWindowSizeChange() // Set width
    window.addEventListener("resize", this.handleWindowSizeChange)
  }

  componentWillMount() {
    // Don’t use this as the API is deprecated
  }

  // make sure to remove the listener
  // when the component is not mounted anymore
  componentWillUnmount() {
    window.removeEventListener("resize", this.handleWindowSizeChange)
  }

  handleWindowSizeChange = () => {
    const minMobileWidth = 980
    this.setState({
      width: window.innerWidth,
      isMobile: window.innerWidth <= minMobileWidth,
    })
  }

  getBodyClass = (isMobile, isHome) => {
    if (isMobile && isHome) return "is-mobile landing"
    if (isHome) return "landing"
    if (isMobile) return "is-mobile"

    return ""
  }

  render() {
    const title = "JKLM Contracts Ltd"
    const description =
      "Homepage for JKLM Contracts Ltd, a multi trade business based in Glasgow."
    const { children, isHome } = this.props
    return (
      <React.Fragment>
        <Helmet
          bodyAttributes={{
            class: this.getBodyClass(this.state.isMobile, isHome),
          }}
        >
          <html lang="en" />
          <title>{title}</title>
          <meta name="description" content={description} />
          <meta name="og:description" content={description} />
          <link
            rel="apple-touch-icon"
            sizes="57x57"
            href="/img/apple-icon-57x57.png"
          />
          <link
            rel="apple-touch-icon"
            sizes="60x60"
            href="/img/apple-icon-60x60.png"
          />
          <link
            rel="apple-touch-icon"
            sizes="72x72"
            href="/img/apple-icon-72x72.png"
          />
          <link
            rel="apple-touch-icon"
            sizes="76x76"
            href="/img/apple-icon-76x76.png"
          />
          <link
            rel="apple-touch-icon"
            sizes="114x114"
            href="/img/apple-icon-114x114.png"
          />
          <link
            rel="apple-touch-icon"
            sizes="120x120"
            href="/img/apple-icon-120x120.png"
          />
          <link
            rel="apple-touch-icon"
            sizes="144x144"
            href="/img/apple-icon-144x144.png"
          />
          <link
            rel="apple-touch-icon"
            sizes="152x152"
            href="/img/apple-icon-152x152.png"
          />
          <link
            rel="apple-touch-icon"
            sizes="180x180"
            href="/img/apple-icon-180x180.png"
          />
          <link
            rel="icon"
            type="image/png"
            sizes="192x192"
            href="/img/android-icon-192x192.png"
          />
          <link
            rel="icon"
            type="image/png"
            sizes="32x32"
            href="/img/favicon-32x32.png"
          />
          <link
            rel="icon"
            type="image/png"
            sizes="96x96"
            href="/img/favicon-96x96.png"
          />
          <link
            rel="icon"
            type="image/png"
            sizes="16x16"
            href="/img/favicon-16x16.png"
          />
          <link rel="manifest" href="/img/manifest.json" />
          <meta name="msapplication-TileColor" content="#ffffff" />
          <meta
            name="msapplication-TileImage"
            content="/img/ms-icon-144x144.png"
          />
          <meta property="og:type" content="website" />
          <meta property="og:title" content={title} />
          <meta property="og:url" content="/" />
        </Helmet>
        <MainNav title={title} isHome={isHome} />
        {children}
        <Footer title={title} isMobile={this.state.isMobile} />
      </React.Fragment>
    )
  }
}

export default Layout
